import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  IBoardCaseDetailModel,
  SilentUpdateTypes,
} from '../../models/BoardCase'

const initialState = {
  data: null as IBoardCaseDetailModel | null,
  error: null as string | null,
  loading: false,

  caseAttachments: {
    temporaryStorage: null as File[] | null,
    tookTooLong: false as boolean,
  },

  hasConflict: false as boolean,
}

const casesSlice = createSlice({
  name: 'case',
  initialState,
  reducers: {
    // Fetch case
    fetchCaseRequest: (state, _: PayloadAction<string>) => {
      state.loading = true
      state.error = null
      state.hasConflict = false
    },
    fetchCaseSuccess: (state, action: PayloadAction<IBoardCaseDetailModel>) => {
      state.loading = false
      state.data = action.payload
    },
    fetchCaseError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    caseReset: (state) => {
      state.data = null
      state.error = null
      state.hasConflict = false
    },
    fetchCaseSilent: (_, _action: PayloadAction<string>) => {},

    updateLastUpdated: (
      state,
      action: PayloadAction<{ type: SilentUpdateTypes; lastUpdated: Date }>
    ) => {
      state.hasConflict = false

      if (state.data) {
        state.data.lastUpdated = action.payload.lastUpdated
      }
    },

    handleUploadTookTooLong: (state, action: PayloadAction<boolean>) => {
      state.caseAttachments.tookTooLong = action.payload
    },

    updateCaseFailedDueToConflict: (state) => {
      state.hasConflict = true
      state.loading = false
    },
  },
})

export default casesSlice
